import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { PageQueryService } from 'src/app/services/page-query.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-stroop-view',
    templateUrl: './stroop-view.component.html',
    styleUrls: ['./stroop-view.component.scss']
})
export class StroopViewComponent implements OnInit, OnDestroy {

    constructor(
        public pageQuery: PageQueryService,
        public loading: LoadingService,
        private http: HttpService,
        private modalService: NgbModal,
        private toastr: ToastrService
    ) { }
    @ViewChild('deleteModal') deleteModal: any;
    private apiPath = 'stroop';
    data: any = {};
    util = UtilitiesService;
    assetUrl = environment.assetUrl;
    isStarted = 0;

    deleteDialog: any = {
        ids: [],
        isDeleting: false,
        modal: null,
        show: (ids: Array<any>) => {
            this.deleteDialog.ids = ids;
            this.deleteDialog.modal = this.modalService.open(this.deleteModal, { keyboard: false, backdrop: 'static', centered: true });
        },
        submit: () => {
            this.deleteDialog.isDeleting = true;
            let urlParameters = Object.entries(this.pageQuery.query.getValue()).filter(k => { return k[1] != null }).map(e => e.join('=')).join('&');
            this.http.Delete(this.apiPath + '/delete?' + urlParameters, this.deleteDialog.ids).then((r: any) => {
                this.deleteDialog.isDeleting = false;
                if (r.success) {
                    this.data = r?.response?.result || {};
                    this.deleteDialog.modal.close();
                }
            });
        }
    }

    setStatus(item: any): void {
        const old_status = item.status;
        item.status = item.status ? 0 : 1;
        this.http.Post(this.apiPath + '/set-status', { id: item.id, status: item.status }).then((r: any) => {
            if (!r.success) {
                item.status = old_status;
                return;
            }
            this.toastr.success('Changes saved successfully');
        });
    }

    answer(data: any[]): any {
        return data.find((e: any) => e.is_true) || {};
    }

    getData(): void {
        const query: any = this.pageQuery.query.getValue() || {};
        query.limit = query?.limit || 10;
        query.page = query?.page || 1;
        query.filter = query?.filter || 'congruent';
        this.http.Get(this.apiPath, query).then((r: any) => {
            if (r.success) {
                this.data = r?.response?.result || {};
                this.isStarted = Number(this.data.quiz_status);
            }
        });
    }

    toggleQuiz(): void {
        this.isStarted = Number(!this.isStarted);
        this.http.Post('quiz-configs/set-status', { name: 'STROOP', status: this.isStarted }).then((r: any) => {
            if (!r.success) {
                return;
            }
            this.toastr.success(`Quiz ${this.isStarted ? 'started' : 'has been stoped'} successfully`);
        });
    }

    ngOnInit(): void {
        if (!this.pageQuery.queryPage?.filter) {
            this.pageQuery.queryPage.filter = 'congruent';
        }
        this.loading.start();
        this.pageQuery.init(() => {
            this.getData();
        });
    }

    ngOnDestroy(): void {
        this.pageQuery.destroy();
    }
}
